module.exports = __webpack_public_path__ + "static/media/background.842d4c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/background.png
// module id = 385
// module chunks = 0